import { useEffect } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { useDispatch, useSelector } from 'react-redux';
import { getPosts } from '../../redux/slices/analytics/topRatedPosts';
import IsUpdatingIndicator from '../isUpdatingIndicator';
import * as PropTypes from 'prop-types';
import PostCard from './post';
import { useLocales } from '../../locales';
import { preLoadImages } from '../../utils/utils';

// eslint-disable-next-line react/prop-types
const TopPlosts = ({ location }) => {
  const { translate: t } = useLocales();
  const dispatch = useDispatch();

  const { isLoading, posts, isUpdating } = useSelector(
    (state) => state.topPosts
  );
  useEffect(() => {
    dispatch(getPosts(location));
  }, [dispatch]);

  useEffect(() => {
    if (isLoading || isUpdating) return;
    const images = [];
    Object.keys(posts).map((key) => {
      return posts[key].map((post) => images.push(post.preview_image_url));
    });
    preLoadImages(images.filter((item) => item != null));
  }, [isLoading, isUpdating]);
  if (isLoading) {
    return <>{t('loading')}</>;
  }
  return (
    <>
      <Row className="row-cols-1 row-cols-md-3 g-4 my-2">
        {Object.keys(posts).map((key, i) => (
          <Col xs={12} sm={6} md={4} key={i}>
            <PostCard posts={posts[key]} key={i} />
          </Col>
        ))}
      </Row>
      <div className="d-flex justify-content-end">
        {isUpdating ? <IsUpdatingIndicator /> : ''}
      </div>
    </>
  );
};

export default TopPlosts;
TopPlosts.propTypes = {
  location: PropTypes.string.isRequired
};
